// extracted by css-extract-rspack-plugin
export default {"Grabber":"grabber-module__Grabber___ZbXGf","grabbing":"grabber-module__grabbing___voztM"};